import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { getOriginalIndexLookupTableByClones } from "./utils/clones";
import { getLookupTableForNextSlides } from "./utils/dots";
import { getSlidesToSlide, notEnoughChildren } from "./utils/common";
const Dots = ({ props, state, goToSlide, getState }) => {
    const { showDots, customDot, dotListClass, infinite, children } = props;
    if (!showDots || notEnoughChildren(state)) {
        return null;
    }
    const { currentSlide, slidesToShow } = state;
    const slidesToSlide = getSlidesToSlide(state, props);
    const childrenArr = React.Children.toArray(children);
    let numberOfDotsToShow;
    if (!infinite) {
        numberOfDotsToShow =
            Math.ceil((childrenArr.length - slidesToShow) / slidesToSlide) + 1;
    }
    else {
        numberOfDotsToShow = Math.ceil(childrenArr.length / slidesToSlide);
    }
    const nextSlidesTable = getLookupTableForNextSlides(numberOfDotsToShow, state, props, childrenArr);
    const lookupTable = getOriginalIndexLookupTableByClones(slidesToShow, childrenArr);
    const currentSlides = lookupTable[currentSlide];
    return (_jsx("ul", Object.assign({ className: `react-multi-carousel-dot-list ${dotListClass}` }, { children: Array(numberOfDotsToShow)
            .fill(0)
            .map((_, index) => {
            let isActive;
            let nextSlide;
            if (!infinite) {
                const maximumNextSlide = childrenArr.length - slidesToShow;
                const possibileNextSlides = index * slidesToSlide;
                const isAboutToOverSlide = possibileNextSlides > maximumNextSlide;
                nextSlide = isAboutToOverSlide
                    ? maximumNextSlide
                    : possibileNextSlides;
                isActive =
                    nextSlide === currentSlide ||
                        (currentSlide > nextSlide &&
                            currentSlide < nextSlide + slidesToSlide &&
                            currentSlide < childrenArr.length - slidesToShow);
            }
            else {
                nextSlide = nextSlidesTable[index];
                const cloneIndex = lookupTable[nextSlide];
                isActive =
                    currentSlides === cloneIndex ||
                        (currentSlides >= cloneIndex &&
                            currentSlides < cloneIndex + slidesToSlide);
            }
            if (customDot) {
                return React.cloneElement(customDot, {
                    index,
                    active: isActive,
                    key: index,
                    onClick: () => goToSlide(nextSlide),
                    carouselState: getState()
                });
            }
            return (_jsx("li", Object.assign({ "data-index": index, className: `react-multi-carousel-dot ${isActive ? "react-multi-carousel-dot--active" : ""}` }, { children: _jsx("button", { "aria-label": `Go to slide ${index + 1}`, onClick: () => goToSlide(nextSlide) }) }), index));
        }) })));
};
export default Dots;
